import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { CategoriaSelectInterface } from "../../interfaces/categoriaInterfaces/CategoriaProductoSelect.interface";
import { ProveedorSelectInterface } from "../../interfaces/proveedorInterfaces/ProveedorSelect.interface";

export async function FindAllProveedorSelectAction(): Promise<
  ApiResponse<ProveedorSelectInterface>
> {
  const { data } = await apiClient.get<ProveedorSelectInterface>(
    "/gpProveedoresProducto/select"
  );
  return {
    status: 200,
    data,
    message: "Proveedor de producto obtenidas correctamente",
  };
}
